export default __webpack_public_path__ + "static/media/filter_icon.90a4a88c.svg";